import * as React from 'react';

import Modal from 'components/bootstrap/Modal';
import type { InvestigationAPIType } from 'security-app/hooks/api/investigationsAPI.types';
import DisclaimerModalContent from 'security-app/components/Investigations/AIReport/DisclaimerModalContent';
import AIReportModalContent from 'security-app/components/Investigations/AIReport/AIReportModalContent';
import useIsInvestigationAIReportEnabled from 'security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled';
import useAITermsAcceptance from 'ai/hooks/useAITermsAcceptance';
import Spinner from 'components/common/Spinner';
import { TELEMETRY_EVENT_TYPE } from 'telemetry/Constants';

type Props = {
  onCancel: () => void;
  investigation: InvestigationAPIType;
};

const telemetryEvents = {
  cancel: TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.TERMS_AND_CONDITIONS_CANCELED,
  consent: TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_REPORT_BY_AI.TERMS_AND_CONDITIONS_CONSENT,
};

const AIReportModal = ({ onCancel, investigation }: Props) => {
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  const {
    data: { accepted },
    isLoading: loadingAcceptance,
    refetch,
  } = useAITermsAcceptance();

  const onConsent = () => {
    refetch();
  };

  return loadingAcceptance ? (
    <Spinner />
  ) : (
    <Modal show={isAIReportFeatureEnabled} onHide={onCancel} bsSize="large">
      {accepted ? (
        <AIReportModalContent onClose={onCancel} investigation={investigation} />
      ) : (
        <DisclaimerModalContent onClose={onCancel} onConsent={onConsent} telemetryEvents={telemetryEvents} />
      )}
    </Modal>
  );
};

export default AIReportModal;
